exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n.slider {\n  position: relative;\n  width: 100%;\n  padding-top: 24px; }\n\n.slider__value-top {\n  display: inline-block;\n  position: absolute;\n  top: -2px;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  margin-bottom: 8px; }\n\n.slider__value {\n  position: absolute;\n  bottom: 0;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  color: #666; }\n\n.slider__value--start {\n  transform: translateX(0%); }\n\n.slider__value--end {\n  transform: translateX(-100%); }\n\n.slider__controls,\n.slider__bar,\n.slider__pin {\n  height: 8px;\n  border-radius: 8px;\n  cursor: pointer; }\n\n.slider__controls {\n  position: relative;\n  background: #c2c2c2; }\n\n.slider__input {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  appearance: none;\n  opacity: 0; }\n\n.slider__bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: #25b8d2;\n  pointer-events: none; }\n\n.slider__bar.slider__bar--upgrade {\n  background: #1797ae; }\n\n.slider__pin {\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n  background: #f54545; }\n  .slider__pin::after {\n    content: \"\";\n    position: absolute;\n    display: block;\n    height: 16px;\n    width: 1px;\n    right: 0;\n    top: -4px;\n    background: #f54545; }\n\n.slider__pin.slider__pin--upgrade {\n  background: #25b8d2;\n  z-index: 1; }\n  .slider__pin.slider__pin--upgrade::after {\n    background: #1797ae; }\n\n.slider__knob {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translateX(50%) translateY(-25%);\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #25b8d2;\n  cursor: pointer; }\n\n.slider__input:focus ~ .slider__bar .slider__knob::after {\n  content: \"\";\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  bottom: -4px;\n  left: -4px;\n  background-color: #25b8d2;\n  border-radius: 50%;\n  opacity: 0.2; }\n\n.slider:active .slider__knob {\n  transform: scale(1.2) translateX(50%) translateY(-25%); }\n\n.slider__labels {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8px;\n  color: #c2c2c2; }\n\n.slider__labels--light {\n  color: #858484;\n  font-size: 12px;\n  vertical-align: bottom; }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};